import {
  MacroSurveyQuestion,
  reset,
  selectAllQuestions,
  selectCurrentQuestion,
  selectError,
  selectRemainingQuestions,
  selectValidationError,
  setCurrentQuestion
} from "../../redux/survey/macroSurveySlice";
import React, {useEffect, useRef} from "react";
import {useTranslation} from "next-i18next";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {Heading3} from "../text";
import {MacroSurveyDietGoalQuestionView} from "./MacroSurveyDietGoalQuestionView";
import {useRouter} from "next/router";
import {MacroSurveyDeadlineQuestionView} from "./MacroSurveyDeadlineQuestion";
import {MacroSurveyBodyTypeQuestionView} from "./MacroSurveyBodyTypeQuestionView";
import {MacroSurveyGenderQuestionView} from "./MacroSurveyGenderQuestionView";
import {MacroSurveyActivityLevelQuestionView} from "./MacroSurveyActivityLevelQuestionView";
import {AlertDialog} from "../dialogs/AlertDialog";
import {MacroSurveyPhysicalDetailsQuestionView} from "./MacroSurveyPhysicalDetailsQuestionView";
import {MacroSurveyDietaryPreferenceQuestionView} from "./MacroSurveyDietaryPreferenceQuestionView";

export const MacroSurveyView: React.FC<any> = ({ }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const router = useRouter()

  const question = useRef<MacroSurveyQuestion>()

  useEffect(() => {
    if (router.query.question === 'diet_goal') {
      question.current = 'diet_goal'
    } else if (router.query.question === 'deadline') {
      question.current = 'deadline'
    } else if (router.query.question === 'gender') {
      question.current = 'gender'
    } else if (router.query.question === 'body_type') {
      question.current = 'body_type'
    } else if (router.query.question === 'activity_level') {
      question.current = 'activity_level'
    } else if (router.query.question === 'physical_details') {
      question.current = 'physical_details'
    } else if (router.query.question === 'goal_weight') {
      question.current = 'goal_weight'
    } else if (router.query.question === 'dietary_preference') {
      question.current = 'dietary_preference'
    } else {
      question.current = 'diet_goal'
    }

    dispatch(setCurrentQuestion(question.current))
  }, [router.query.question, dispatch])

  const validationError = useAppSelector(selectValidationError)
  const allQuestions = useAppSelector(selectAllQuestions)
  const remainingQuestions = useAppSelector(selectRemainingQuestions)
  const currentQuestion = useAppSelector(selectCurrentQuestion)
  const error = useAppSelector(selectError)

  useEffect(() => {
    dispatch(reset())
  }, [dispatch])

  return <div className="md:max-w-lg md:rounded-xl md:border-2 md:border-fg-gray-surface md:py-8 mx-auto mt-10 mb-10">
    <AlertDialog
      isOpen={!!error}
      error={error}
      buttons={[
        {
          title: { key: 'common:common_title_ok' },
          onClick: () => {
            dispatch(reset())
          },
          style: 'default'
        }
      ]}
    />

    <AlertDialog
      isOpen={!!validationError}
      error={validationError}
      buttons={[
        {
          title: { key: 'common:common_title_ok' },
          onClick: () => {
            dispatch(reset())
          },
          style: 'default'
        }
      ]}
    />

    <Heading3 className="text-center mb-4 lg:mb-6" >
      {t('macro_survey:macro_survey_header_progress_title', { current: allQuestions.length - (remainingQuestions.length - 1), total: allQuestions.length })}
    </Heading3>

    <div className={`${question.current === 'diet_goal' ? '' : 'hidden'}`}>
      <MacroSurveyDietGoalQuestionView />
    </div>

    <div className={`${question.current === 'deadline' ? '' : 'hidden'}`}>
      <MacroSurveyDeadlineQuestionView />
    </div>

    <div className={`${question.current === 'gender' ? '' : 'hidden'}`}>
      <MacroSurveyGenderQuestionView />
    </div>

    <div className={`${question.current === 'body_type' ? '' : 'hidden'}`}>
      <MacroSurveyBodyTypeQuestionView />
    </div>

    <div className={`${question.current === 'activity_level' ? '' : 'hidden'}`}>
      <MacroSurveyActivityLevelQuestionView />
    </div>

    <div className={`${question.current === 'physical_details' ? '' : 'hidden'}`}>
      <MacroSurveyPhysicalDetailsQuestionView />
    </div>

    <div className={`${question.current === 'dietary_preference' ? '' : 'hidden'}`}>
      <MacroSurveyDietaryPreferenceQuestionView />
    </div>
  </div>
}